import { ReactNode } from 'react';
import { toast, ToastOptions } from 'react-toastify';
import { IToastApi } from '@vivli/shared/infrastructure/interface';
export const useToastApi = () => {
    const info = (msg: ReactNode, options?: ToastOptions) =>
        toast.info(msg, {
            toastId: 'info-toast', // prevent dups by assigning a non-unique id
            ...options
        });

    const error = (msg: ReactNode, options?: ToastOptions) =>
        toast.error(msg, {
            toastId: 'error-toast', // prevent dups by assigning a non-unique id
            ...options
        });

    const success = (msg: ReactNode, options?: ToastOptions) =>
        toast.success(msg, {
            toastId: 'success-toast', // prevent dups by assigning a non-unique id
            ...options
        });

    const toastProvider: IToastApi = {
        info,
        error,
        success,
        dismiss: toast.dismiss
    };

    return toastProvider;
};
